import { render, staticRenderFns } from "./table-cell.vue?vue&type=template&id=a8215c02&scoped=true"
import script from "./table-cell.vue?vue&type=script&lang=ts"
export * from "./table-cell.vue?vue&type=script&lang=ts"
import style0 from "./table-cell.vue?vue&type=style&index=0&id=a8215c02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8215c02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8215c02')) {
      api.createRecord('a8215c02', component.options)
    } else {
      api.reload('a8215c02', component.options)
    }
    module.hot.accept("./table-cell.vue?vue&type=template&id=a8215c02&scoped=true", function () {
      api.rerender('a8215c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/table/table-cell.vue"
export default component.exports